import React from 'react/addons';
import {FluxMixin} from 'fluxxor';

import Icon from 'ofs/components/common/Icon';


var InfoTip = React.createClass({
  mixins: [FluxMixin(React)],

  getDefaultProps: function() {
    return {
      icon: 'question',
      size: 'small',
    };
  },

  handleSelect(value, states) {
    this.props.onChange(value, states);
  },

  handleClick(event) {
    var trigger = this.getDOMNode();
    event.preventDefault();
    this.getFlux().actions.layers.addTooltip(<div
      trigger={trigger}
      panelAttachment="top middle"
      targetAttachment="bottom middle"
      value={this.props.value}>{this.props.children}</div>);
  },

  render() {
    const { size } = this.props;
    return (
      <div className="ofs-InfoTip" onClick={this.handleClick}>
        <Icon glyph={this.props.icon} size={size} />
      </div>
    );
  }
});

export default InfoTip;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/common/InfoTip.jsx
 **/